import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-liverpool',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './liverpool.component.html',
  styleUrl: './liverpool.component.scss'
})
export class LiverpoolComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.liverpool;
}
